import { CSSProperties } from 'react';
import { Box, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
// NOTE(DS migration): ConfirmPopup is a shared (non-commonComponents) modal with no DS equivalent — kept.
import ConfirmPopup from '~/components/shared/ConfirmPopup';
import HeartIcon from '~/images/icons/Heart';
import { CheckIcon } from '~/images/icons/CheckIcon';

// ── inline styles (no DS prop equivalent) ──────────────────────────────────
/** marginBottom has no DS Box prop */
const calloutRowStyle: CSSProperties = { marginBottom: 16 };
/** border/background/radius/marginBottom have no DS Box prop */
const calloutBoxStyle: CSSProperties = {
  border: `1.5px solid ${colors.favorites['400']}`,
  backgroundColor: colors.favorites['30'],
  borderRadius: 8,
  boxSizing: 'border-box',
  marginBottom: 24,
};
/** lineHeight has no DS Typography prop */
const calloutTextStyle: CSSProperties = { lineHeight: 1.4 };

interface IFavoriteAddedPopupProps {
  professionalName: string;
  onClose: () => void;
}

export const FavoriteAddedPopup = ({ professionalName, onClose }: IFavoriteAddedPopupProps) => (
  // @ts-expect-error - missing type
  <ConfirmPopup
    dataCy="favorite-added-popup"
    title="Congrats!"
    description={`${professionalName} has been added to your Favorites.`}
    descriptionStyle={{ marginBottom: 16 }}
    rightButtonText="Close"
    rightButtonAction={onClose}
    rightButtonDataCy="favorite-added-close-button"
    closePopup={onClose}
  >
    <Row align="center" gap={2} style={calloutRowStyle}>
      <HeartIcon color={colors.favorites['400']} width={20} height={20} outline={false} />
      <Typography bold size="body_large" color={colors.favorites['400']}>
        Added to Favorites
      </Typography>
      <CheckIcon color={colors.favorites['400']} size={20} />
    </Row>

    <Box width="90%" p={4} style={calloutBoxStyle}>
      <Typography color={colors.neutral['500']} textAlign="center" style={calloutTextStyle}>
        This professional is now a Favorite! To speed up coverage when posting shifts, turn on
        Auto-Confirm for Favorites to reconnect with confidence.
      </Typography>
    </Box>
  </ConfirmPopup>
);
